import { useContext } from 'react';
import { createContext } from 'react';

import { GiftTextProps } from '../@types/GiftTextProps';

export const GiftTextContext = createContext<GiftTextProps>({} as GiftTextProps);

GiftTextContext.displayName = 'GiftText';

const GiftTextProvider = (props: GiftTextProps) => (
	<GiftTextContext.Provider value={props}>{props.children}</GiftTextContext.Provider>
);

export const useGiftText = () => {
	const context = useContext(GiftTextContext);

	return context;
};

export default GiftTextProvider;
